const initImagesSlider = () => {
	const imagesSections = document.querySelectorAll('.images'),
		  breakpoint = window.matchMedia('(min-width: 768px)');



	imagesSections.forEach(images => {
		let swiperImages;

		const breakpointChecker = function() {
			if ( breakpoint.matches === true ) {

				if ( swiperImages !== undefined ) swiperImages.destroy( true, true );
				return;
			} else if ( breakpoint.matches === false ) {
				return enableSwiper();
			}
		};

		const enableSwiper = function() {
			swiperImages = new Swiper('.images', {
				autoplay: {
					delay: 3000,
				},
			});
		}

		breakpoint.addEventListener("change", breakpointChecker);
		breakpointChecker();
	});
};

window.addEventListener('DOMContentLoaded', () => {
	initImagesSlider();
});